@switch (order_type_id) {
  @case (2) {
    <ts-device-to-upgrade
      [order_type_settings]="
        (shopping_cart && shopping_cart.order_type_settings) || additional_info.order_type_settings
      "
      [asset]="asset_details.existing_asset"
      [keep_plan]="asset_details.keep_plan"
      [card_wrap]="card_wrap"
    />
  }
  @case (3) {
    <ts-device-to-activate
      [shopping_cart]="shopping_cart"
      [field_error_messages]="validation_errors"
      [existing_asset]="asset_details.existing_asset"
      [is_review_or_summary]="review || confirmation || summary"
      [sim_summary_details]="additional_info.sim_options"
      [asset_fields]="device_to_activate_fields"
      [card_wrap]="card_wrap"
      (valid_sim_form)="handleSimForm($event)"
    />
  }
  @case (6) {
    <ts-activity-6-my-line
      class="d-block mb-3"
      [asset]="
        asset_details.existing_asset.asset_from_inventory ? asset_details.existing_asset : undefined
      "
      [card_wrap]="card_wrap"
    />
    @if (!card_wrap) {
      <hr class="mx-n3" />
    }
    @if (additional_info && additional_info.travel_details) {
      <div [ngClass]="[card_wrap ? 'card shadow-sm' : '']">
        <div [ngClass]="{ 'card-body': card_wrap }">
          <h4 class="mb-3" [ngClass]="{ 'card-title': card_wrap }">
            {{ 'travel_details' | translate }}
          </h4>
          <ts-travel-details-readonly [travel_details]="additional_info.travel_details" />
        </div>
      </div>
    }
  }
  @case ([8, 9].includes(order_type_id) && order_type_id) {
    <ts-asset-card
      class="d-block mb-3"
      header="{{ (order_type_id === 8 ? 'line_to_assign' : 'device_to_assign') | translate }}"
      [asset]="asset_details.existing_asset"
      [asset_fields]="
        order_type_id === 8
          ? ['plan', 'sim_number', 'add_on_features', 'contract_end_date']
          : ['imei', 'imei2', 'serial_number']
      "
      [card_wrap]="card_wrap"
    />
    @if (!card_wrap) {
      <hr class="mx-n3" />
    }
    <ts-person-assignment
      [is_review_or_summary]="review || confirmation || summary"
      [asset_details]="asset_details"
      [shopping_cart]="shopping_cart"
      [card_wrap]="card_wrap"
      (update_replacement_person)="updateReplacementPerson($event)"
    />
  }
  @case (12) {
    <ts-asset-card
      class="mb-3"
      header="{{ 'selected_line' | translate }}"
      [asset]="asset_details.existing_asset"
      [asset_fields]="['plan', 'plan_features', 'add_on_features']"
      [card_wrap]="card_wrap"
    />
    <ts-revised-features-readonly [shopping_cart]="shopping_cart" />
  }
  @case (13) {
    <ts-asset-card
      class="mb-3"
      header="{{ 'line_to_transfer' | translate }}"
      [asset]="asset_details.existing_asset"
      [asset_fields]="['plan', 'plan_features', 'add_on_features']"
      [card_wrap]="card_wrap"
    />
    @if (!card_wrap) {
      <hr class="mx-n3" />
    }
    @if (additional_info && additional_info.transfer_of_liability_attributes) {
      <div [ngClass]="[card_wrap ? 'card shadow-sm' : '']">
        <div [ngClass]="{ 'card-body': card_wrap }">
          <h4 class="mb-3" [ngClass]="{ 'card-title': card_wrap }">
            {{ 'transfer_details' | translate }}
          </h4>
          <ts-transfer-details-readonly
            [transfer_of_liability_attributes]="additional_info.transfer_of_liability_attributes"
          />
          @if (shipping_address) {
            <div class="row">
              <div class="col d-flex flex-column">
                <hr class="mx-n3" />
                <label class="form-label"> {{ 'return_shipping_address' | translate }} </label>
                <span>{{ shipping_address.company_name }}</span>
                <span>{{ shipping_address.address1 }}</span>
                <span>{{ shipping_address.address2 }}</span>
                <span>
                  {{ shipping_address.city }},
                  {{ shipping_address.state }}
                  {{ shipping_address.zip }}
                </span>
                <span>{{ shipping_address.country }}</span>
              </div>
            </div>
          }
        </div>
      </div>
    }
  }
  @default {
    @if (asset_config.header) {
      <ts-asset-card
        [header]="asset_config.header"
        [asset]="asset_config.asset"
        [asset_fields]="asset_config.asset_fields"
        [card_wrap]="asset_config.card_wrap"
      />
    }
  }
}
